<!-- https://github.com/ProofFactorLLC/proof-factor-widget -->
<div class="fortune-wheel-preview-container conveythis-no-translate">
  <div *ngIf="withBrowser" class="Browser-Header" [style.width]="sizes && sizes.width"
       [class._mobile-header]="previewService.previewDevice.isMobile || false">
    <div class="arrow"></div>
  </div>
  <iframe
    [class._centered]="sizes && sizes['width'] !== null"
    [class.m-0]="!withBrowser"
    [attr.src]="!iFrameSRC ? null : iFrameSRC | safe"
    (load)="onLoad()"
    #iFrame
    [ngStyle]="sizes"
    [ngClass]="previewClass"
    frameborder="0"
    [scrolling]="scrolling"
    hspace="0"
    vspace="0"
    marginheight="0"
    marginwidth="0"
  ></iframe>
</div>
<!--<div class="_imageBg" *ngIf="sizes && sizes['width'] === null"></div>-->
<!--<div class="_overlayBg" *ngIf="sizes && sizes['width'] === null" [style.background-color]="overlayBg"></div>-->
<div *ngIf="notLoaded" class="text-muted small text-center">
  Preview is not available
  <div *ngIf="!production">(most likely widget can't be loaded)</div>
</div>
